import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockArticles } from '../services/dataService';
import { getArticleImage } from '../utils/imageUtils';

/**
 * Article Details Page Component
 */
const ArticleDetails = () => {
  const { id } = useParams();
  const article = mockArticles.find(a => a.id === id);

  if (!article) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <h2>Article not found</h2>
        <Link to="/articles" className="btn btn-primary" style={{ marginTop: '20px' }}>Back to Articles</Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <Link to="/articles" className="btn btn-secondary" style={{ marginBottom: '20px' }}>
        ← Back to Articles
      </Link>

      <article className="card">
        <img 
          src={getArticleImage(article.id, article.title)} 
          alt={article.title}
          style={{ 
            width: '100%', 
            maxWidth: '800px',
            height: '400px', 
            objectFit: 'cover', 
            borderRadius: '8px', 
            marginBottom: '20px',
            display: 'block',
            margin: '0 auto 20px'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <h1 style={{ fontSize: '36px', color: 'var(--highlight-color)', marginBottom: '20px' }}>
          {article.title}
        </h1>

        <div style={{ 
          display: 'flex', 
          gap: '20px', 
          marginBottom: '30px', 
          paddingBottom: '20px',
          borderBottom: '2px solid var(--card-hover)',
          flexWrap: 'wrap'
        }}>
          <div>
            <strong>Category:</strong> {article.category}
          </div>
          <div>
            <strong>Author:</strong> {article.author}
          </div>
          <div>
            <strong>Published:</strong> {article.publishedDate}
          </div>
          <div>
            <strong>Status:</strong> {article.status}
          </div>
        </div>

        <div style={{ 
          color: 'var(--text-dark)', 
          lineHeight: '1.8', 
          fontSize: '18px',
          whiteSpace: 'pre-wrap'
        }}>
          <p style={{ marginBottom: '20px' }}>{article.content}</p>
          <p style={{ marginBottom: '20px' }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          <p style={{ marginBottom: '20px' }}>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <p>
            Space exploration continues to evolve, with new technologies and missions pushing the boundaries of human knowledge 
            and capability. From reusable rockets to Mars colonization, the future of space travel is more exciting than ever.
          </p>
        </div>
      </article>
    </div>
  );
};

export default ArticleDetails;
